<script setup lang="ts">
  import { useVisitorForm } from '@procommerce/visitor';

  type OrderShipping = {
    shipping_option_id: number | null;
    shipping_option_name: string | null;
  }

  const { data } = useVisitorForm<OrderShipping>();
</script>
<template>
  <div class="shipping-option-summary" v-if="data.shipping_option_id">
    <SfIconTruck class="shipping-option-summary__icon" />
    <div class="shipping-option-summary__content">
      <span class="shipping-option-summary__property">{{ $t('Sposób dostawy') + ':' }}</span>
      <span class="shipping-option-summary__value">{{ data.shipping_option_name }}</span>
    </div>
  </div>
</template>
<style lang="scss">
  .shipping-option-summary {
    display: flex;
    gap: 0.75rem;
    padding: 0.75rem 1.5rem;

    &__icon {
      font-size: 1.25rem;
    }

    &__content {
      display: flex;
      flex-direction: column;
    }

    &__value {
      font-weight: var(--font-weight-semi);
    }
  }
</style>
